import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export const toolings = [
  {
    title: "Languages & Tools",
    programmingLanguages: [
      { name: "Python", level: 95, color: "from-blue-400 to-yellow-400", icons: ""},
      { name: "TypeScript", level: 70, color: "from-blue-500 to-blue-700", icons: ""},
      { name: "JavaScript", level: 90, color: "from-yellow-400 to-yellow-600", icons: "" },
      { name: "Java", level: 55, color: "from-red-500 to-orange-500", icons: "" },
      { name: "HTML", level: 50, color: "from-blue-600 to-purple-600", icons: "" },
      { name: "XML", level: 50, color: "from-blue-400 to-blue-600", icons: "" },
      { name: "CSS", level: 50, color: "from-blue-400 to-blue-600", icons: "" },
      { name: "PHP", level: 50, color: "from-blue-400 to-blue-600", icons: "" },
    ]
  },
  {
    title: "Frameworks & Libraries",
    programmingLanguages: [
      { name: "NodeJS, ExpressJS, NextJS", level: 85, color: "from-green-500 to-green-700", icons: "" },
      { name: "Django, Flask, Falcon, FastApi", level: 80, color: "from-blue-500 to-cyan-500", icons: "" },
      { name: "React, VueJS, Angular", level: 90, color: "from-cyan-400 to-blue-500", icons: "" },
      { name: "React Native", level: 85, color: "from-yellow-400 to-orange-400", icons: "" },
      { name: "PyTorch, TensorFlow", level: 92, color: "from-cyan-400 to-teal-500", icons: "" },
      { name: "Scikit-learn", level: 85, color: "from-green-400 to-green-600", icons: "" },
      { name: "Pandas, NumPy", level: 85, color: "from-purple-500 to-indigo-600", icons: "" },
      { name: "Matplotlib, Seaborn", level: 85, color: "from-purple-500 to-indigo-600", icons: "" },
    ]
  },
  {
    title: "Databases & DevOps",
    programmingLanguages: [
      { name: "SQL (PostgreSQL, MySQL)", level: 80, color: "from-blue-700 to-indigo-700", icons: "" },
      { name: "Redis, NoSQL", level: 85, color: "from-gray-400 to-gray-600", icons: "" },
      { name: "Vector Databases", level: 85, color: "from-gray-400 to-gray-600", icons: "" },
      { name: "AWS (EC2, Lambda, RDS, etc..)", level: 78, color: "from-blue-400 to-cyan-500", icons: "" },
      { name: "Docker", level: 78, color: "from-blue-400 to-cyan-500", icons: "" },
      { name: "Git, GitHub, GitLab", level: 90, color: "from-orange-500 to-red-500", icons: "" },
      { name: "Linux, Bash Scripting", level: 85, color: "from-yellow-400 to-orange-400", icons: "" },
      { name: "Object–relational Mapping (ORM)", level: 75, color: "from-purple-400 to-pink-400", icons: "" },
    ]
  },
  {
    title: "AI & Other Tools",
    programmingLanguages: [
      { name: "LangChain, LangGraph", level: 60, color: "from-green-100 to-blue-400", icons: "" },
      { name: "Vercel AI SDK", level: 60, color: "from-green-100 to-blue-400", icons: "" },
      { name: "Hugging Face", level: 85, color: "from-yellow-400 to-orange-400", icons: "" },
      { name: "Model Context Protocol", level: 85, color: "from-purple-400 to-pink-400", icons: "" },
      { name: "Retrieval-Augmented Generation", level: 88, color: "from-purple-400 to-pink-400", icons: "" },
      { name: "LLMs (OpenAI, Gemini, Anthropic)", level: 88, color: "from-purple-400 to-pink-400", icons: "" },
      { name: "Ollama", level: 80, color: "from-green-500 to-emerald-500", icons: "" },
      { name: "GraphQL, RESTfull, WebSocket", level: 75, color: "from-purple-400 to-pink-400", icons: "" },
    ]
  }
]

  export const skills = {
    "Primary Skills": [
      { name: "Software Development", level: 100, color: "from-blue-400 to-yellow-400" },
      { name: "Machine Learning", level: 100, color: "from-yellow-400 to-yellow-600" },
      { name: "DevOps (AWS Tools)", level: 100, color: "from-cyan-400 to-blue-500" },
      { name: "Data Science", level: 100, color: "from-blue-700 to-indigo-700" },
    ]
  };


const Skills = () => {
  const [showAllSkills, setShowAllSkills] = useState(false);
  const [activeCategory, setActiveCategory] = useState("All");



  const getFilteredSkills = () => {
    if (activeCategory === "All") {
      const allSkills = Object.entries(skills).reduce(
        (acc, [category, skills]) => {
          return [...acc, ...skills.map((skill) => ({ ...skill, category }))];
        },
        []
      );
      return showAllSkills ? allSkills : allSkills.slice(0, 12);
    } else {
      const categorySkills = skills[activeCategory] || [];
      return showAllSkills ? categorySkills : categorySkills.slice(0, 8);
    }
  };

  const filteredSkills = getFilteredSkills();
  const totalSkills =
    activeCategory === "All"
      ? Object.values(skills).reduce(
          (acc, skills) => acc + skills.length,
          0
        )
      : skills[activeCategory]?.length || 0;

  const shouldShowViewMore =
    activeCategory === "All"
      ? totalSkills > 12
      : (skills[activeCategory]?.length || 0) > 8;

  return (
    <div className="container mx-auto px-6">
      <h2 className="text-5xl font-bold text-center bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent mb-12">
        Technical or Trade Skills
      </h2>


      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
        {filteredSkills.map((skill, index) => (
          <div
            key={index}
            className="bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-sm border border-gray-700/50 rounded-xl p-6 hover:border-cyan-500/50 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 transform hover:-translate-y-1"
          >
            <div className="mb-3">
              <h3 className="text-white font-semibold text-lg text-center">{skill.name}</h3>
            </div>

            {/* Progress Bar */}
            <div className="w-full bg-gray-700 rounded-full h-2 overflow-hidden">
              <div
                className={`h-full bg-gradient-to-r ${skill.color} rounded-full transition-all duration-1000 ease-out`}
                style={{ width: `${skill.level}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>


      {shouldShowViewMore && (
        <div className="text-center">
          <button
            onClick={() => setShowAllSkills(!showAllSkills)}
            className="flex items-center justify-center mx-auto px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-500 text-white font-semibold rounded-lg hover:from-cyan-400 hover:to-purple-400 transition-all duration-300 transform hover:scale-105"
          >
            {showAllSkills ? (
              <>
                <FaChevronUp className="mr-2" />
                Show Less
              </>
            ) : (
              <>
                <FaChevronDown className="mr-2" />
                View All Skills (
                {totalSkills - (activeCategory === "All" ? 12 : 8)} more)
              </>
            )}
          </button>
        </div>
      )}

          <section>
            <h2 className="text-5xl font-bold text-center bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent mb-12">
              Tech Stack
            </h2>
            <div className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-6">
              {toolings.map((tool, index) => (
                <div
                  key={index}
                  className="break-inside-avoid mb-6 bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-sm border border-gray-700/50 rounded-xl shadow-2xl p-6 transition-all duration-300 hover:-translate-y-2 hover:shadow-cyan-500/20 hover:border-cyan-500/50"
                >
                  <h3 className="text-xl font-semibold text-white border-b border-gray-600 pb-2 mb-4">
                    {tool.title}
                  </h3>
                  {tool.programmingLanguages && (
                    <div className="space-y-4">
                      {tool.programmingLanguages.map((lang, idx) => (
                        <div key={idx} className="">
                          <span
                            className="inline-block mt-4 px-4 py-2 bg-gradient-to-r from-cyan-500 to-purple-500 text-white rounded-lg text-sm font-medium hover:from-cyan-400 hover:to-purple-400 transition-all duration-300"
                          >
                            {lang.name}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </section>
    </div>
  );
};

export default Skills;
